export default "__VITE_ASSET__CS5FX$WX__"